export default __webpack_public_path__ + "static/media/cp_geo_ie.93368369.svg";